import MuiBox from "@mui/material/Box";
import type { BoxProps as MuiBoxProps } from "@mui/material/Box";

export type BoxProps = MuiBoxProps;

export function Box({ children, sx, ...props }: BoxProps) {
  return (
    <MuiBox sx={sx} {...props}>
      {children}
    </MuiBox>
  );
}
